// extracted by mini-css-extract-plugin
export default {"dashboard":"DashboardLayout_dashboard__lP+Hm","dashboardContainer":"DashboardLayout_dashboardContainer__Ba8bz","open":"DashboardLayout_open__NAQQU"};